// extracted by mini-css-extract-plugin
export default {"text":"zILMb","b400":"ygAOy","b300":"IWd7k","b200":"ApuIi","b100":"jKojr"};